export default "__VITE_ASSET__D_q87YVh__"